import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mb-12px"
};
const _hoisted_2 = {
  class: "flex text-[var(--el-text-color-primary)] justify-between items-center"
};
const _hoisted_3 = {
  class: "text-[var(--el-text-color-secondary)] text-12px my-8px"
};
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Index'
  },
  __name: 'index',
  props: {
    title: {
      type: String
    },
    desc: {
      type: String
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(__props.title), 1), _renderSlot(_ctx.$slots, "extra")]), _createElementVNode("div", _hoisted_3, _toDisplayString(__props.desc), 1), _renderSlot(_ctx.$slots, "default")]);
    };
  }
});